module.exports = __webpack_public_path__ + "static/media/strip2_resized.847b08ee.png";